import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Text from '../../partials/Text';

import styles from '../../../../styles/blocks/employee/text.module.scss';

const propTypes = {
    dropCap: PropTypes.bool,
    indent: PropTypes.bool,
    body: PropTypes.string,
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
};

const defaultProps = {
    dropCap: false,
    indent: false,
    body: null,
    className: null,
    isContainer: false,
    containerClassName: null,
};

const TextBlock = ({ dropCap, indent, body, className, isContainer, containerClassName }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
    >
        <Text
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
            dropCap={dropCap}
            indent={indent}
            body={body}
        />
    </div>
);

TextBlock.propTypes = propTypes;
TextBlock.defaultProps = defaultProps;

export default TextBlock;
